import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import { FC, useEffect, useState } from 'react';

import Logo from './Logo';
import Menu from './Menu';

const BACKGROUND: Record<'normal' | 'scrolled', string> = {
  normal: 'linear-gradient(180deg, rgba(0,0,0,0.5) 25%, rgba(0,0,0,0) 95%)',
  scrolled: 'linear-gradient(180deg, rgba(0, 0, 0, 0.75) 66%, rgba(0, 0, 0, 0) 100%)',
};

const SX_HEADER: SxProps<Theme> = {
  height: 'var(--header-h)',
  left: 0,
  position: 'fixed',
  top: 0,
  width: '100vw',
  zIndex: 50,
};

const Header: FC = () => {
  const [background, setBackground] = useState<string>('');

  useEffect(() => {
    const handleScroll = (): void => {
      setBackground(window.scrollY > 50 ? BACKGROUND.scrolled : BACKGROUND.normal);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return (): void => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Box component='header' sx={{ ...SX_HEADER, background }}>
      <Menu />
      <Logo />
    </Box>
  );
};

export default Header;
